import axios from "axios";
import React, { useEffect, useRef, useState, useContext } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { timer } from "rxjs";
import OrderBook from "./OrderBook";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { DataContext } from ".";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ImportExportIcon from "@mui/icons-material/ImportExport";

const LeftTable = () => {
  const { setCurrencycode, setBasecurrency, currencycode, basecurrency } =
    useContext(DataContext);
  const theme = localStorage.getItem("theme");
  const { brokerBasicInfo, btncolor } = useSelector((state) => state);
  const [show, setShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("");
  const [currency, setCurrency] = useState("BTC");
  const [filterCurrency, setFilterCurrency] = useState([]);
  const [dropdownFiatList, setDropdownFiatList] = useState([]);
  const [assetetpair, setAssetetpair] = useState([]);
  const [assetetpairback, setAssetetpairback] = useState([]);
  const [assetetpairbackOrigin, setAssetetpairbackOriginal] = useState([]);
  const [roccolor, setRoccolor] = useState(false);
  const [ltpcolor, setLtpcolor] = useState(null);
  const [sort, setSort] = useState(false);
  const [showFiat, setShowFiat] = useState(false);
  const [fiatSelected, setFiatSelected] = useState("FIAT");
  const [newFiatArray, setNewFiatArray] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleClose = () => setShow(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const handleSelect = (data) => {
    setSelected(data);
    setIsOpen(!isOpen);
  };

  // useEffect(() => {
  //   const storedTradeP = localStorage.getItem("tradep");
  //   if (storedTradeP) {
  //     setTradep(parseInt(storedTradeP));
  //   }
  // }, []);

  useEffect(() => {
    setSelected(`${currencycode.toUpperCase()}/${basecurrency.toUpperCase()}`);

    getNewCurrency();
    getUserBalance();
  }, []);

  const getUserBalance = () => {
    const userTransObj = {
      customerId: localStorage.getItem("userId"),
      uuid: localStorage.getItem("uuid"),
    };

    const jsonString = JSON.stringify(userTransObj);

    axios
      .post(`${WEBSERVICE}transaction/getUserBalance`, jsonString, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const result = response.data;
        const userBalanceList = result.userBalanceList;

        if (userBalanceList != null) {
          console.log("new fiat data all pairs", userBalanceList);

          const fiatCurrencies = userBalanceList
            .filter((item) => item.currencyType === 1)
            .map((item) => item.currencyCode);

          setNewFiatArray(fiatCurrencies);
          console.log("new fiat data", fiatCurrencies);
        }

        if (result.error?.error_data !== 0) {
          // data.alert('Cannot fetch user balance', 'danger');
        }
      })
      .catch((error) => {
        // if (error.response?.status === 401 || error.response?.status === 400) {
        //   //logout
        //   showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        // } else if (![200, 429, 403].includes(error.response?.status)) {
        //   // data.alert(error.message, 'warning');
        // }
      });
  };

  const getNewCurrency = async (currency = "BTC") => {
    setCurrency(currency);
    setLoading(true);
    try {
      const response = await axios.get(
        `https://accounts.paybito.com/CacheService/api/getAssetsData?Name=Assets&BrokerId=${localStorage.getItem(
          "BROKERID"
        )}`
      );

      const filterCurrencyData = JSON.parse(response.data.value);
      localStorage.setItem(
        "spot_assets",
        JSON.stringify(filterCurrencyData.Values)
      );

      console.log("filterCurrencyData", filterCurrencyData);

      setFilterCurrency(filterCurrencyData);
      const assets = filterCurrencyData.Values;

      const basecur = assets.filter(
        (x) => x.baseCurrency === "USDT" && x.currencyCode === "BTC"
      );

      const fiat1 = assets.filter((x) => x.currencyType === 1);
      const fiat2 = [...new Set(fiat1.map((item) => item.baseCurrency))];

      setDropdownFiatList(fiat2);

      // changeMessage1(basecur[0].amountPrecision);
      // changeMessage2(basecur[0].pricePrecision);

      // Find the active asset based on the current currencycode and basecurrency
      const activeAsset = assets.find(
        (x) =>
          x.currencyCode?.toUpperCase() === currencycode?.toUpperCase() &&
          x.baseCurrency?.toUpperCase() === basecurrency?.toUpperCase()
      );

      if (activeAsset) {
        localStorage.setItem("amountprc", activeAsset.amountPrecision);
        localStorage.setItem("priceprc", activeAsset.pricePrecision);
        localStorage.setItem("assetCode", activeAsset.assetCode);
      } else {
        // Fallback to basecur[0] if activeAsset is not found
        if (basecur && basecur.length > 0) {
          localStorage.setItem("amountprc", basecur[0].amountPrecision);
          localStorage.setItem("priceprc", basecur[0].pricePrecision);
          localStorage.setItem("assetCode", basecur[0].assetCode);
        } else {
          localStorage.setItem("amountprc", "6");
          localStorage.setItem("priceprc", "6");
        }
      }

      const basrcurrency = currency; // Replace with appropriate value
      const newAssetetpair = [];
      console.log("currency", currency, assets);
      assets.forEach((asset) => {
        let isRocPositive = asset.roc > 0 ? true : false;
        let ltpColor =
          asset.action === "buy"
            ? true
            : asset.action === "sell"
            ? false
            : null;

        if (basrcurrency === asset.baseCurrency) {
          newAssetetpair.push({
            currencycode: asset.currencyCode,
            basecurrency: asset.baseCurrency,
            lasttrade1: asset.ltpValue,
            lasttrade2: asset.ltpConvValue,
            lpricecolor: ltpColor,
            roc: asset.roc,
            volume: asset.volume,
            isRocPositive: isRocPositive,
            amountPrecision: asset.amountPrecision,
            pricePrecision: asset.pricePrecision,
            assetCode: asset.assetCode,
          });
        } else if (basrcurrency === "ALL") {
          if (
            asset.currencyType === 1 &&
            newFiatArray.includes(asset.baseCurrency) == true
          ) {
            newAssetetpair.push({
              currencycode: asset.currencyCode,
              basecurrency: asset.baseCurrency,
              lasttrade1: asset.ltpValue,
              lasttrade2: asset.ltpConvValue,
              lpricecolor: ltpColor,
              roc: asset.roc,
              volume: asset.volume,
              amountPrecision: asset.amountPrecision,
              pricePrecision: asset.pricePrecision,
              assetCode: asset.assetCode,
            });
          }
        } else if (basrcurrency === "OTHER") {
          if (
            !["AED", "USD", "INR", "ETH", "BTC"].includes(asset.baseCurrency)
          ) {
            let lastprice = `${parseFloat(asset.ltpValue)}/${
              asset.ltpConvValue
            }`;
            newAssetetpair.push({
              currencycode: asset.currencyCode,
              basecurrency: asset.baseCurrency,
              lasttrade: lastprice,
              roc: asset.roc,
              volume: asset.volume,
              amountPrecision: asset.amountPrecision,
              pricePrecision: asset.pricePrecision,
              assetCode: asset.assetCode,
            });
          }
        }

        setRoccolor(isRocPositive);
        setLtpcolor(ltpColor);
      });

      console.log("newAssetetpair->", newAssetetpair);

      setAssetetpair(newAssetetpair);
      setAssetetpairback([...newAssetetpair]);
      setAssetetpairbackOriginal([...newAssetetpair]);
      setLoading(false);
      // changeDetectorRef.detectChanges();
    } catch (error) {
      setLoading(false);
      console.error("Error fetching asset data", error);
    }
  };
  // console.log("assetetpairback--->", assetetpairback);

  const handleCurrencySelect = (d) => {
    setSelected(`${d?.currencycode}/${d?.basecurrency}`);
    setCurrencycode(d?.currencycode);
    setBasecurrency(d?.basecurrency);
    localStorage.setItem("buying_crypto_asset", d?.currencycode);
    localStorage.setItem("selling_crypto_asset", d?.basecurrency);
    setIsOpen(false);
  };

  const handleSearch = (searchText) => {
    if (searchText !== "") {
      const filterData = assetetpairbackOrigin?.filter((data) =>
        data?.currencycode.includes(searchText.toUpperCase())
      );
      setAssetetpairback(filterData);
    } else {
      setAssetetpairback(assetetpairbackOrigin);
    }
  };

  const handleVolumnToggle = () => {
    if (sort) {
      const sortData = assetetpairback.sort((a, b) => a?.volume - b?.volume);
      setAssetetpairback(sortData);
      setSort(false);
    } else {
      const sortData = assetetpairback.sort((a, b) => b?.volume - a?.volume);
      setAssetetpairback(sortData);
      setSort(true);
    }
  };
  const handleSelectFiat = (text) => {
    setFiatSelected(text);
    setShowFiat(false);
  };

  const websocket = {
    stompClient: null,
    unsubscribe: () => console.log("Unsubscribed"),
    _disconnect: () => console.log("WebSocket Disconnected"),
    _connect: () => console.log("WebSocket Connected"),
    subscribe: () => console.log("WebSocket Subscribed"),
  };

  const trade = {
    reload: () => console.log("Trade reloaded"),
    myTradeDisplay: (value) => console.log("My Trade Display: ", value),
  };

  const callTradeHistory = (action) =>
    console.log("Trade History called with action: ", action);

  const setTradeData = (updateFunction) =>
    console.log("Trade Data Updated", updateFunction);

  const buySellCode = (item) => {
    let previousCurrency =
      localStorage.getItem("buying_crypto_asset")?.toUpperCase() || "";
    let previousBaseCurrency =
      localStorage.getItem("selling_crypto_asset")?.toUpperCase() || "";

    if (item.currencycode === "BTC" && item.basecurrency === "USD") {
      websocket.unsubscribe();
      websocket._disconnect();
    } else if (previousCurrency === "BTC" && previousBaseCurrency === "USD") {
      websocket.unsubscribe();
      websocket._disconnect();
    } else {
      websocket.unsubscribe();
    }

    if (websocket.stompClient !== null) {
      setTimeout(() => {
        if (item.currencycode === "BTC" && item.basecurrency === "USD") {
          websocket?._connect();
        } else if (
          previousCurrency === "BTC" &&
          previousBaseCurrency === "USD"
        ) {
          websocket?._connect();
        } else {
          websocket?.subscribe();
        }
      }, 1000);
    }

    setTradeData((prev) => {
      const updatedData = { ...prev };
      updatedData.selectedSellingAssetText = item.basecurrency;
      updatedData.selectedBuyingAssetText = item.currencycode;
      updatedData.selectedBuyingCryptoCurrencyName =
        item.basecurrency + item.currencycode;
      updatedData.selectedSellingCryptoCurrencyName =
        item.currencycode + item.basecurrency;
      updatedData.selectedSellingCryptoCurrencyissuer = "";
      updatedData.selectedBuyingCryptoCurrencyissuer = "";
      return updatedData;
    });

    localStorage.setItem(
      "buying_crypto_asset",
      item.currencycode.toLowerCase()
    );
    localStorage.setItem(
      "selling_crypto_asset",
      item.basecurrency.toLowerCase()
    );
    localStorage.setItem("amountprc", item.amountPrecision);
    localStorage.setItem("priceprc", item.pricePrecision);
    localStorage.setItem("assetCode", item.assetCode);
    localStorage.setItem("isAssetPairChangedRecently", "true");
    localStorage.setItem("isResetTheStoplossfieldForSpot", "true");

    let assetChangeCounter = localStorage.getItem("assetChangeCounterForSpot");
    if (assetChangeCounter) {
      assetChangeCounter = parseInt(assetChangeCounter) + 1;
    } else {
      assetChangeCounter = 1;
    }
    localStorage.setItem("assetChangeCounterForSpot", assetChangeCounter);

    trade.reload();
    trade.myTradeDisplay(0);

    callTradeHistory("click");

    document.getElementById("trade")?.click();
    // document.getElementById("dropHolder").style.overflow = "scroll";

    window.addEventListener("resize", () => {
      const wd = document.getElementById("chartHolder")?.offsetWidth;
      if (wd) {
        document.getElementById("dropHolder").style.width = `${wd}px`;
        document.getElementById("dropHolder").style.overflow = "scroll";
      }
    });
  };

  return (
    <>
      <div
        className="currency_Container tour1"
        style={{
          backgroundColor: btncolor,
        }}
      >
        <p
          className="currency_text d-flex align-items-center justify-content-center"
          onClick={handleToggle}
        >
          {selected}
          {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </p>
      </div>
      {isOpen && (
        <div
          className="dropdown_"
          style={{ backgroundColor: "var(--body-color)" }}
        >
          <div
            className="search_container"
            tabindex="0"
            style={{ margin: "5px" }}
          >
            <i class="fa-solid fa-magnifying-glass"></i>
            <input
              type="text"
              placeholder="Search"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>
          <div
            className="currency_ d-flex justify-content-around align-items-center"
            style={{ marginTop: "5px" }}
          >
            {filterCurrency?.Header?.length !== 0 &&
              filterCurrency?.Header?.map((data, i) => (
                <p
                  key={i}
                  onClick={() => getNewCurrency(data)}
                  style={{
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "var(--text-color)",
                  }}
                >
                  {data}
                </p>
              ))}
            {/* <p onClick={() => setShowFiat(!showFiat)}>{fiatSelected}</p> */}
            <Dropdown
              style={{
                backgroundColor: "var(--body-color-less)",
                border: "none",
              }}
            >
              <Dropdown.Toggle
                id="dropdown-basic"
                style={{
                  backgroundColor: "var(--body-color-less)",
                  color: "var(--text-color)",
                  border: "none",
                }}
              >
                {fiatSelected}
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={{
                  maxHeight: "200px",
                  overflowY: "scroll",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                <Dropdown.Item
                  onClick={() => (
                    handleSelectFiat("ALL"), getNewCurrency("ALL")
                  )}
                >
                  ALL
                </Dropdown.Item>
                {newFiatArray.length !== 0 &&
                  newFiatArray?.map((data, i) => (
                    <Dropdown.Item
                      key={i}
                      onClick={() => (
                        handleSelectFiat(data), getNewCurrency(data)
                      )}
                    >
                      {data}
                    </Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
            <p />
          </div>
          {loading && (
            <div className="loading style-2">
              <div className="loading-wheel"></div>
            </div>
          )}
          <div
            className="table_content_dropdown"
            style={{ maxHeight: "200px", margin: "4px" }}
          >
            <table>
              <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                <th
                  style={{
                    textAlign: "start",
                    backgroundColor: "var(--body-color-less3)",
                  }}
                >
                  Pair
                </th>
                <th
                  style={{
                    textAlign: "center",
                    backgroundColor: "var(--body-color-less3)",
                  }}
                >
                  Last Price
                </th>
                <th style={{ backgroundColor: "var(--body-color-less3)" }}>
                  ROC
                </th>
                <th
                  style={{
                    cursor: "pointer",
                    backgroundColor: "var(--body-color-less3)",
                  }}
                  onClick={handleVolumnToggle}
                >
                  <ImportExportIcon sx={{ fontSize: "16px" }} /> Volume
                </th>
              </thead>
              <tbody style={{ overflowY: "scroll" }}>
                {assetetpairback?.length !== 0 &&
                  assetetpairback?.map((d, i) => (
                    <tr
                      key={i}
                      onClick={() => buySellCode(d)}
                      style={{ cursor: "pointer" }}
                    >
                      <td
                        style={{
                          fontWeight: "bold",
                          cursor: "pointer",
                          textAlign: "start",
                          color: theme === "light" ? "rgb(0, 123, 255)" : "",
                        }}
                        onClick={() => handleCurrencySelect(d)}
                      >
                        <img
                          src={`https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/${d?.currencycode}.png`}
                          alt="vtho"
                          style={{
                            height: "14px",
                            width: "14px",
                            margin: "5px 3px 5px 0",
                          }}
                        />
                        {d?.currencycode}/{d?.basecurrency}
                      </td>
                      <td className="text-end">
                        <span
                          style={{
                            color:
                              d?.lpricecolor === false
                                ? "rgb(255, 0, 122)"
                                : d?.lpricecolor === true
                                ? "rgb(112,168, 0)"
                                : "rgb(245,245,220)",
                          }}
                        >
                          {d?.lasttrade1} &nbsp;
                        </span>
                        {/* <span style="color:rgb(161, 161, 159);" *ngIf="m.basecurrency=='INR'"> ₹ </span><span
                      style="color:rgb(161, 161, 159);" *ngIf="m.basecurrency =='USD' || m.basecurrency=='USDT'"> $
                    </span><span style="color:rgb(161, 161, 159);" *ngIf="m.basecurrency=='EUR'"> €</span><span
                      style="color:rgb(161, 161, 159);" *ngIf="m.basecurrency=='SGD'">S$</span> */}

                        <span style={{ color: "rgb(161, 161, 159)" }}>
                          /{" "}
                          {d?.basecurrency == "INR"
                            ? " ₹ "
                            : d?.basecurrency == "USD" ||
                              d?.basecurrency == "USDT"
                            ? "$"
                            : d?.basecurrency == "EUR"
                            ? "€"
                            : "S$"}
                        </span>
                        <span style={{ color: "rgb(161, 161, 159)" }}>
                          {d?.lasttrade2}
                        </span>
                      </td>
                      <td
                        style={{
                          color: d?.isRocPositive
                            ? "rgb(112,168, 0)"
                            : "rgb(255, 0, 122)",
                        }}
                      >
                        {(d?.roc).toFixed(2)}
                      </td>
                      <td style={{ color: theme === "light" ? "black" : "" }}>
                        {d?.volume}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <OrderBook />
    </>
  );
};

export default LeftTable;
